import { useDropzone } from "react-dropzone";
import { Button, Container } from "reactstrap";
// import styled from 'styled-components';
const getColor = (props) => {
  if (props.isDragAccept) {
    return "#00e676";
  }
  if (props.isDragReject) {
    return "#ff1744";
  }
  if (props.isFocused) {
    return "#2196f3";
  }
  return "#eeeeee";
};
// const Container = styled.div`
//   flex: 1;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   padding: 40px;
//   border-width: 2px;
//   border-radius: 10px;
//   border-color: ${(props) => getColor(props)};
//   border-style: dashed;
//   background-color: #fafafa;
//   color: black;
//   font-weight: bold;
//   font-size: 1.4rem;
//   outline: none;
//   transition: border 0.24s ease-in-out;
// `;
function DropBox({ onDrop, accept, onCancel }) {
  const {
    getRootProps,
    getInputProps,
    // acceptedFiles,
    open,
    // isDragAccept,
    // isFocused,
  } = useDropzone({
    accept: accept || {
      "image/*": [".jpg", ".png", ".jpeg", ".webp"],
      "video/*": [".mp4", ".mov"],
      "application/octet-stream": [".glb", ".gltf"],
    },
    onDrop,
    noClick: true,
    noKeyboard: true,
  });
  return (
    <>
      <section className="dropbox">
        <Container className="dropbox-container" {...getRootProps({})}>
          <input {...getInputProps()} />
          <p>Drag 'n' drop here</p>

          <Button color="primary mr-2" className="btn-sm" onClick={open}>
            select file
          </Button>
          <a color="secondary ml-2" className="btn" onClick={onCancel}>
            Cancel
          </a>
        </Container>
      </section>
    </>
  );
}
export default DropBox;
